/* Cristina Gavino — cuenta atrás de campaña */
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-cg-countdown]').forEach(function (el) {
      if (el.__cgInit) return; el.__cgInit = true;
      var fin = new Date(el.getAttribute('data-cg-countdown')).getTime();
      if (isNaN(fin)) return;
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function tick() {
        var diff = Math.max(0, fin - Date.now());
        var t = Math.floor(diff / 1000);
        if (d) d.textContent = pad(Math.floor(t / 86400));
        if (h) h.textContent = pad(Math.floor((t % 86400) / 3600));
        if (m) m.textContent = pad(Math.floor((t % 3600) / 60));
        if (s) s.textContent = pad(t % 60);
        if (diff <= 0) { el.setAttribute('data-terminado', ''); clearInterval(iv); }
      }
      var iv = setInterval(tick, 1000); tick();
    });
  }
  /* Barra de anuncios: gira de forma continua, sin pausa al pasar el ratón, tocar o enfocar */
  function initAnuncios(root) {
    (root || document).querySelectorAll('[data-cg-rotar]').forEach(function (bar) {
      if (bar.__cgRotar) clearInterval(bar.__cgRotar);
      var slides = Array.prototype.slice.call(bar.querySelectorAll('.announcement-bar__slide'));
      if (slides.length < 2) return;
      var seg = parseFloat(bar.getAttribute('data-cg-rotar')) || 4;
      var i = 0;
      function mostrar(n) {
        slides.forEach(function (s, k) {
          var activo = k === n;
          s.setAttribute('aria-hidden', activo ? 'false' : 'true');
          s.querySelectorAll('a').forEach(function (a) { a.tabIndex = activo ? 0 : -1; });
        });
      }
      mostrar(0);
      bar.__cgRotar = setInterval(function () { i = (i + 1) % slides.length; mostrar(i); }, seg * 1000);
    });
  }
  /* Colección: al pulsar un círculo de color (SA Variants), ir directamente a la ficha de ese color */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.swatches-type-collections [swatch-url]');
    if (!sw) return;
    var url = sw.getAttribute('swatch-url');
    if (!url) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = url;
  }, true);
  /* Selectores de color (SA Variants): mostrar solo 5 opciones y un botón "+N" que despliega el resto */
  var CG_MAX_SW = 5;
  function limitarSwatches(ul) {
    var items = Array.prototype.filter.call(ul.children, function (li) { return li.classList.contains('swatch-view-item'); });
    var viejo = ul.querySelector(':scope > .cg-sw-mas');
    if (items.length <= CG_MAX_SW) { if (viejo) viejo.remove(); return; }
    if (ul.__cgAbierto) { items.forEach(function (li) { li.classList.remove('cg-sw-oculto'); }); }
    else {
      var sel = items.filter(function (li) { return li.getAttribute('aria-checked') === 'true' || li.classList.contains('swatch-selected'); })[0];
      var visibles = sel ? [sel] : [];
      for (var i = 0; i < items.length && visibles.length < CG_MAX_SW; i++) { if (items[i] !== sel) visibles.push(items[i]); }
      items.forEach(function (li) { li.classList.toggle('cg-sw-oculto', visibles.indexOf(li) === -1); });
    }
    var resto = items.length - CG_MAX_SW;
    var mas = viejo || document.createElement('li');
    if (!viejo) {
      mas.className = 'cg-sw-mas';
      mas.setAttribute('role', 'button');
      mas.setAttribute('tabindex', '0');
      mas.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        ul.__cgAbierto = !ul.__cgAbierto; limitarSwatches(ul);
      });
      mas.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); mas.click(); } });
    }
    mas.textContent = ul.__cgAbierto ? '−' : '+' + resto;
    mas.setAttribute('aria-label', ul.__cgAbierto ? 'Ver menos colores' : 'Ver ' + resto + ' colores más');
    var ref = items[0].querySelector('.swatch-image-wrapper, .swatch-image') || items[0];
    var w = ref.getBoundingClientRect().width, h = (items[0].querySelector('.star-set-image') || ref).getBoundingClientRect().height;
    if (w) mas.style.setProperty('--cg-sw-w', Math.round(w) + 'px');
    if (h) mas.style.setProperty('--cg-sw-h', Math.round(h) + 'px');
    mas.classList.toggle('cg-sw-mas--redondo', !!ul.closest('.swatches-type-collections') || ul.classList.contains('swatch-view-circle') || (w && h && Math.abs(w - h) < 4 && w < 60));
    if (ul.lastElementChild !== mas) ul.appendChild(mas);
  }
  function revisarSwatches(root) {
    (root || document).querySelectorAll('ul.swatch-view').forEach(limitarSwatches);
  }
  var cgSwTimer;
  new MutationObserver(function (muts) {
    var relevante = muts.some(function (m) { return !(m.target.classList && m.target.classList.contains('cg-sw-mas')) && (m.target.closest ? m.target.closest('.swatches') : null); });
    if (!relevante) return;
    clearTimeout(cgSwTimer); cgSwTimer = setTimeout(function () { revisarSwatches(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-checked', 'class'] });
  function init(root) { initCountdowns(root); initAnuncios(root); revisarSwatches(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAnuncios(e.target.closest('.shopify-section') || document); });
})();
